import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import Skeleton from 'react-loading-skeleton'

import { bemJoin } from 'bem-join'
import { Cluster } from 'component-library-next'

import { CourtCasePaymentEventType } from '@app/graphql/types'
import { useIntl } from '@app/intl/Intl'
import { ChoiceField } from '@app/lib/fields/ChoiceField/ChoiceField'
import { Radio } from '@app/lib/inputs/Radio/Radio'
import { Text } from '@app/lib/typography/Text/Text'
import { useInvoicingDefaultValuesContext } from '@app/modules/CourtCases/Components/CourtCaseInvoicingForm/Components/InvoicingDefaultValuesContext/InvoicingDefaultValuesContext'
import { useUpdateProceduralFeeFactor } from '@app/modules/CourtCases/Components/CourtCaseInvoicingForm/hooks/useUpdateProceduralFeeFactor'

export const InvoicingInstancesSection = () => {
  const b = bemJoin('court-case-invoicing-form')
  const { formatMessage } = useIntl()
  const { watch, setValue } = useFormContext()
  const { loadingDefaultValues, setDefaultValues } = useInvoicingDefaultValuesContext()
  const { updateProceduralFeeFactor } = useUpdateProceduralFeeFactor()

  const selectedInstance = watch('Instance')

  useEffect(() => {
    setDefaultValues()
    updateProceduralFeeFactor()
  }, [selectedInstance, setValue, setDefaultValues, updateProceduralFeeFactor])

  return (
    <div className={b('section')}>
      <Text size={'ml'} weight={'bold'}>
        {formatMessage({ id: 'CourtCases.Invoicing.Section.Instances.Title' })}
      </Text>
      {loadingDefaultValues ? (
        <Skeleton />
      ) : (
        <ChoiceField<CourtCasePaymentEventType>
          defaultValue={CourtCasePaymentEventType.FirstInstance}
          name='Instance'
          label={formatMessage({ id: 'CourtCases.Invoicing.Field.BillingType' })}
          render={({ register }) => (
            <Cluster role='radiogroup'>
              <Radio
                {...register({
                  value: CourtCasePaymentEventType.FirstInstance
                })}
              >
                {formatMessage({
                  id: 'CourtCases.Invoicing.Option.Instances.First'
                })}
              </Radio>
              <Radio
                {...register({
                  value: CourtCasePaymentEventType.SecondInstance
                })}
              >
                {formatMessage({
                  id: 'CourtCases.Invoicing.Option.Instances.Second'
                })}
              </Radio>
              <Radio
                {...register({
                  value: CourtCasePaymentEventType.ThirdInstance
                })}
              >
                {formatMessage({
                  id: 'CourtCases.Invoicing.Option.Instances.Third'
                })}
              </Radio>
            </Cluster>
          )}
        />
      )}
    </div>
  )
}
